import { usePostHog } from '@posthog/react'
import { useAppSelector } from '@/redux/hooks'
import { usePages } from '@/hooks'

export const PortalFooter = () => {
  const posthog = usePostHog()

  const { currentPage } = usePages()

  const ecommerceGroup = useAppSelector(
    (store) => store.settingsApi.settings.response.ecommerce_group
  )

  const ecommerceId = useAppSelector(
    (store) => store.settingsApi.settings.response.ecommerce_id
  )

  const checkoutId = useAppSelector(
    (store) => store.returnsApi.order.response?.checkout_id
  )

  const handleClick = () => {
    posthog.capture('Click powered by REVER', {
      ecommerce_group: ecommerceGroup,
      ecommerce_id: ecommerceId,
      checkout_id: checkoutId,
      source: currentPage
    })
  }

  return (
    <footer className="mx-auto mt-auto">
      <a
        href="https://itsrever.com/"
        target="_blank"
        rel="noreferrer"
        onClick={handleClick}
        className="inline-flex items-center gap-1 text-xs font-normal text-grey-1"
      >
        Powered by{' '}
        <span aria-label="REVER">
          <svg
            width="44"
            height="12"
            viewBox="0 0 44 12"
            fill="none"
            aria-hidden
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M31.2515 11.436H24.6983L27.4067 0.5H33.9134L33.3842 2.61513H29.5393L29.01 4.74591H32.31L31.7963 6.86104H28.4963L27.8893 9.32087H31.7808L31.2515 11.436Z"
              fill="#6B7280"
            />
            <path
              d="M21.921 11.436H17.9205L17.9049 0.5H20.4733L20.3799 9.08585L24.3493 0.5H27.1978L21.921 11.436Z"
              fill="#6B7280"
            />
            <path
              d="M15.1067 11.436H8.55344L11.2619 0.5H17.7685L17.2392 2.61513H13.3945L12.8652 4.74591H16.1652L15.6515 6.86104H12.3515L11.7445 9.32087H15.636L15.1067 11.436Z"
              fill="#6B7280"
            />
            <path
              d="M2.97556 11.436H0.5L3.20848 0.5H6.52638C8.68951 0.5 9.85481 2.53967 9.58435 4.16351C9.33043 5.68804 8.25415 6.79992 7.08615 7.24999L8.54131 8.77015L7.77379 11.5L4.4294 8.00267L5.07003 5.52464C6.76139 5.40818 7.14655 4.34559 7.14655 3.73265C7.14655 3.11974 6.76839 2.61512 5.82354 2.61512H5.21686L2.97556 11.436Z"
              fill="#6B7280"
            />
            <path
              d="M42.4026 1.77669V0.898738H42.6614C42.7138 0.898738 42.7626 0.9088 42.8075 0.928925C42.8525 0.948212 42.8888 0.977141 42.9164 1.01571C42.9447 1.05429 42.9588 1.10083 42.9588 1.15533C42.9588 1.20732 42.946 1.25218 42.9199 1.28992C42.8943 1.32681 42.8593 1.35197 42.8149 1.36539C42.8509 1.37293 42.8763 1.39012 42.8914 1.41696C42.9061 1.44295 42.9167 1.47523 42.9225 1.51381L42.9299 1.58425C42.9341 1.63288 42.9389 1.67188 42.9437 1.70122C42.9489 1.73057 42.9572 1.75573 42.9688 1.77669H42.7713C42.7639 1.76328 42.7584 1.7465 42.7552 1.72638C42.7526 1.70625 42.7501 1.67649 42.7475 1.63707C42.7469 1.62953 42.7456 1.61443 42.744 1.59179C42.743 1.56832 42.7408 1.54777 42.7375 1.53016C42.726 1.46392 42.6842 1.43079 42.6126 1.43079H42.5876V1.77669H42.4026ZM42.6614 1.27985C42.6939 1.27985 42.7196 1.26979 42.7388 1.24967C42.7581 1.22954 42.7674 1.20145 42.7674 1.16539C42.7674 1.12933 42.7581 1.10125 42.7388 1.08112C42.7196 1.06016 42.6939 1.04967 42.6614 1.04967H42.5876V1.27985H42.6614Z"
              fill="#6B7280"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M42.6582 0.68744C42.2962 0.68744 42.0027 0.982856 42.0027 1.34727C42.0027 1.71168 42.2962 2.0071 42.6582 2.0071C43.0203 2.0071 43.3138 1.71168 43.3138 1.34727C43.3138 0.982856 43.0203 0.68744 42.6582 0.68744ZM41.8165 1.34727C41.8165 0.879336 42.1933 0.500001 42.6582 0.500001C43.1231 0.500001 43.5 0.879336 43.5 1.34727C43.5 1.8152 43.1231 2.19454 42.6582 2.19454C42.1933 2.19454 41.8165 1.8152 41.8165 1.34727Z"
              fill="#6B7280"
            />
            <path
              d="M34.4863 11.436H32.0106L34.7191 0.5H38.0371C40.2003 0.5 41.3653 2.53967 41.0949 4.16351C40.8409 5.68804 39.7648 6.79992 38.5968 7.24999L40.0519 8.77015L39.2844 11.5L35.9401 8.00267L36.5808 5.52464C38.2718 5.40818 38.6572 4.34559 38.6572 3.73265C38.6572 3.11974 38.2789 2.61512 37.3341 2.61512H36.7275L34.4863 11.436Z"
              fill="#6B7280"
            />
          </svg>
        </span>
      </a>
    </footer>
  )
}
